import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';

import { SessionService } from './session.service';

/**
 * Navigation gate (FR-032, R-006): unauthenticated navigation is cancelled
 * with a RedirectCommand to /sign-in carrying the full attempted URL as
 * returnUrl. Guards run per navigation, so a session lost while idle is
 * caught at the next attempt. Structural control, not a security boundary —
 * enforcement is API-side (AITH-43/AITH-78).
 */
export const sessionGuard: CanActivateFn = (_route, state) => {
  const session = inject(SessionService);
  if (session.isAuthenticated()) return true;
  const router = inject(Router);
  return new RedirectCommand(
    router.createUrlTree(['/sign-in'], { queryParams: { returnUrl: state.url } }),
  );
};
